export default "__VITE_ASSET__CGQMfDQi__"